import React, { useState, useContext } from 'react';
import { ToolBar } from '../pageElements';
import { Button, Icon, ScrollView } from '../ui';
import EntryCaption from './EntryCaption';
import EntryContent from './EntryContent';
import EntryMeasurements from './EntryMeasurements';
import PanelNavSmall from './PanelNavSmall';
import DateModal from './DateModal';
import { EditorContext } from './EditorContext';
import { back } from '../../lib/helpers/navigate';

const Small: React.FC = () => {
  const initialActiveTab = 'DATA';
  const [activeTab, setActiveTab] = useState<'DATA' | 'CAPTION' | 'NOTE'>(initialActiveTab);
  const [showDateModal, setShowDateModal] = useState(false);
  const { state, dispatch } = useContext(EditorContext);

  return (
    <>
      {showDateModal && (
        <DateModal
          closeModal={() => setShowDateModal(false)}
          selectedDate={state.input.notedAt}
          setSelectedDate={(value: Date) => dispatch({ type: 'selectEntryDate', value })}
        />
      )}
      <ToolBar className="justify-between ph3 bb b--light-gray">
        <button onClick={() => back()} data-testid="cancel-note-button">
          <Icon name="close" />
        </button>
        <button
          className="blue hover-navy pointer"
          onClick={() => dispatch({ type: 'saveEntry' })}
          data-testid="save-note-button"
        >
          Save
        </button>
      </ToolBar>

      <ScrollView className="flex-auto">
        <div className="flex-auto flex flex-column">
          <PanelNavSmall
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            showDateModal={setShowDateModal}
          />

          {activeTab === 'DATA' && (
            <div className="flex-auto w-100 mw6-ns center ph3 pb4 pt2">
              <EntryMeasurements />
            </div>
          )}
          {activeTab === 'CAPTION' && (
            <div className="ph3 w-100 mw6-ns center">
              <EntryCaption />
            </div>
          )}
          {activeTab === 'NOTE' && (
            <div className="ph3 w-100 mw6-ns center">
              <EntryContent />
            </div>
          )}
        </div>
      </ScrollView>
    </>
  );
};

export default Small;
